import { IconValueCellRenderer, LinkCellRenderer } from '@components';
import { Api } from '@services';
import Axios from 'axios';
import { useState } from 'react';
import { PagedQueryParams, ServerSideGrid } from '../../components/grids/AgGrid/ServerSideGrid';
import { PagedModel } from '../../models/PagedModel';
import { PlaceListModel } from '../../models/PlaceListModel';
import { placeListColumnDefs } from './columnDefs';
import { V2FilterPayload } from '../..//components/AssetFilter/functions/V2FilterPayload';

function PlaceListScreen<T>() {
  const [rowData, setRowData] = useState<any>(new PagedModel<T>());
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const id = 'Places';
  const cancelToken = Api.CancelToken;
  let fetchDataCancel;

  const fetchData = async (payload, csvExport, queryState) => {
    if (fetchDataCancel !== null && typeof fetchDataCancel === 'function') {
      fetchDataCancel();
      fetchDataCancel = null;
    }
    setIsLoading(true);

    const requestPayload = V2FilterPayload(
      [],
      'and',
      queryState.skip(),
      queryState.setSort(),
      queryState.pageSize,
      [],
      queryState.filter || '',
    );

    Api.post('v2/places/filtered', requestPayload, {
      cancelToken: new cancelToken(function executor(c) {
        fetchDataCancel = c;
      }),
    })
      .then((data) => {
        setRowData(data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        if (!Axios.isCancel(e)) {
          setIsLoading(false);
        }
      });
  };

  return (
    <ServerSideGrid<PlaceListModel>
      id={id}
      columnDefs={placeListColumnDefs}
      initQueryParams={new PagedQueryParams(id)}
      handleFetchData={fetchData}
      rowData={rowData}
      isLoading={isLoading}
      disabledFilters={[]}
      filterControl={false}
      searchControl={true}
      viewingControl={true}
      pagerControl={true}
      gridProps={{
        frameworkComponents: {
          LinkCellRenderer,
          IconValueCellRenderer,
        },
      }}
    />
  );
}

export default PlaceListScreen;
